import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var GlobalRichText = function GlobalRichText() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalRichText.vue');
};

export default {
  name: 'SimpleParagraph',
  components: {
    GlobalRichText: GlobalRichText
  },
  props: {
    paragraph: {
      type: Array,
      required: true
    },
    hasReadMore: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      hideText: this.hasReadMore
    };
  }
};